import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { format } from 'date-fns';
import { useAuthLogs } from '@/hooks/useAuthLogs';

export function AuthLogsCard() {
  const { data: logs = [], isLoading } = useAuthLogs();

  const failedLogins = logs.filter(log => 
    log.event_message?.includes('fail') || 
    log.event_message?.includes('error') ||
    log.status >= 400
  );

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Authentication Logs</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center text-muted-foreground">Loading...</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Authentication Logs</CardTitle>
        <CardDescription>
          Recent authentication events ({failedLogins.length} failed attempts)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[180px]">Timestamp</TableHead>
                <TableHead className="w-[100px]">Status</TableHead>
                <TableHead>Path</TableHead>
                <TableHead>Message</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-muted-foreground">
                    No auth logs found
                  </TableCell>
                </TableRow>
              ) : (
                logs.slice(0, 20).map((log) => (
                  <TableRow key={log.id}>
                    <TableCell className="font-mono text-sm">
                      {format(new Date(log.timestamp / 1000), 'MMM dd, HH:mm:ss')}
                    </TableCell>
                    <TableCell>
                      {log.status >= 400 ? (
                        <Badge variant="destructive">{log.status}</Badge>
                      ) : log.status >= 200 && log.status < 300 ? (
                        <Badge variant="success">
                          {log.status}
                        </Badge>
                      ) : (
                        <Badge variant="secondary">{log.status}</Badge>
                      )}
                    </TableCell>
                    <TableCell className="font-mono text-xs">{log.path}</TableCell>
                    <TableCell className="text-sm truncate max-w-[400px]">
                      {log.msg || log.event_message}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
